export default __webpack_public_path__ + "static/media/listo02.66dbb687.svg";